import fetchRequest from '../common/fetchRequest';

export default function fetchDownloads (url, method = 'GET', data) {
    return fetchRequest(url, { method, data });
}



// WEBPACK FOOTER //
// ./src/scripts/components/downloads-list/fetchDownloads.js